export default "__VITE_ASSET__1OOEqamn__"